import React, { FC, useEffect, useState } from 'react';
import {
  Box,
  Card,
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  Paper,
} from '@material-ui/core';
import { usePermissions, useTranslate } from 'react-admin';
import moment from 'moment';
import { Title, CollapsibleAccountsSection } from '~/components';
import { NoPermissions } from '~/components/ra';
import RaTabbedShowLayout from '~/theme/overrides/RaTabbedShowLayout';
import { useTenantAccountsReport } from '~/hooks/reports';

export const l = (key: string): string => `resources.reports.tenantAccounts.${key}`;

const TenantAccountsReport: FC<any> = () => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  const t = (key: string, options?: any): string => translate(l(key), options);

  const hasPermission = permissions?.includes('report.tenantAccounts.view');

  const [responseTime, setResponseTime] = useState<string | null>(null);

  useEffect(() => {
    setResponseTime(moment().format('LL LT'));
  }, []);

  const { data: report, isLoading } = useTenantAccountsReport(!!hasPermission);

  if (!permissions) return null;
  if (!hasPermission) return <NoPermissions />;
  if (isLoading) {
    return (
      <Box p={3} display='flex' justifyContent='center'>
        <CircularProgress />
      </Box>
    );
  }

  const groups = [...(report || [])].sort((a, b) => a.productName.localeCompare(b.productName));

  return (
    <>
      <Title
        resource='reports.tenantAccounts'
        headline={t('title')}
        subtitle={t('subtitle', { responseTime })}
      />
      <Card>
        <div style={RaTabbedShowLayout.content}>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableBody>
                {groups.map((group) => (
                  <CollapsibleAccountsSection
                    key={group.productId}
                    title={
                      <>
                        <b>{group.productName}</b> ({group.accounts.length})
                      </>
                    }
                    accounts={[...group.accounts].sort((a, b) =>
                      (a.alias || a.number).localeCompare(b.alias || b.number)
                    )}
                    aliasLabel={t('alias')}
                    numberLabel={t('number')}
                    postedAmountLabel={t('postedAmount')}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Card>
    </>
  );
};

export default TenantAccountsReport;
